// Archivo: EntradasHistorial.jsx
// (Modificado para incluir Entradas Y Salidas)
import React, { useEffect, useState } from "react";
import api from "../services/api";
import { 
  normalizarFecha, 
  formatearFechaLegible, 
  obtenerFechaLocal 
} from "../utils/dateUtils";




const EntradasHistorial = () => {
  const [items, setItems] = useState([]); // <-- Renombrado de 'entradas' a 'items'
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });
  const [filtroEstado, setFiltroEstado] = useState("todas");
  const [modalDetalle, setModalDetalle] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  
  // 📅 Filtros de fecha - por defecto últimos 30 días
const [fechaInicio, setFechaInicio] = useState(() => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
});
const [fechaFin, setFechaFin] = useState(obtenerFechaLocal());
const [verRechazados, setVerRechazados] = useState(false);


  const getNombreDepartamento = (departamento_id) => {
  if (!departamento_id) return '—';
  const dept = departamentos.find(d => d.id === departamento_id);
  return dept ? dept.nombre : `Dept. ${departamento_id}`;
};

  const cargarItems = async () => {
  try {
    setLoading(true);
    
    const [entradasRes, salidasRes, departamentosRes] = await Promise.all([
      api.get('/entradas'),
      api.get('/salidas'),
      api.get('/departamentos')
    ]);

  // 📦 AGRUPAR ENTRADAS POR LOTE
const entradas = entradasRes.data;
const entradasAgrupadas = [];
const lotesEntradaYaProcesados = new Set();

entradas.forEach(entrada => {
  // Si es parte de un lote de entrada y aún no lo procesamos
  if (entrada.es_lote && entrada.lote_entrada_id && !lotesEntradaYaProcesados.has(entrada.lote_entrada_id)) {
    // Buscar todas las entradas de este lote
    const entradasDelLote = entradas.filter(e => e.lote_entrada_id === entrada.lote_entrada_id);
    
    // Crear un objeto "lote" agrupado
    entradasAgrupadas.push({
      id: entrada.lote_entrada_id,
      tipo: 'entrada-lote',
      es_lote: true,
      lote_entrada_id: entrada.lote_entrada_id,
      numero_factura: entrada.numero_factura,
      proveedor: entrada.proveedor,
      fecha_adquisicion: entrada.fecha_adquisicion,
      responsable: entrada.responsable,
      estado: entrada.estado,
      createdAt: entrada.createdAt,
      motivo_rechazo: entrada.motivo_rechazo,
      aprobado_por: entrada.aprobado_por,
      fecha_aprobacion: entrada.fecha_aprobacion,
      items: entradasDelLote.map(e => ({
        id: e.id,
        material_codigo: e.material?.codigo || e.codigo || 'N/A',
        material_nombre: e.material?.nombre || e.descripcion || 'Material desconocido',
        cantidad: e.cantidad,
        costo_unitario: e.costo_unitario,
        valor_total: e.valor_total,
        MaterialId: e.MaterialId,
        estado: e.estado
      })),
      cantidad_total: entradasDelLote.reduce((sum, e) => sum + e.cantidad, 0),
      valor_total: entradasDelLote.reduce((sum, e) => sum + parseFloat(e.valor_total || 0), 0),
      cantidad_items: entradasDelLote.length
    });
    
    lotesEntradaYaProcesados.add(entrada.lote_entrada_id);
  } 
  // Si NO tiene lote_entrada_id (entradas individuales)
  else if (!entrada.lote_entrada_id) {
    entradasAgrupadas.push({ ...entrada, tipo: 'entrada' });
  }
});

// 📦 AGRUPAR SALIDAS POR LOTE
const salidas = salidasRes.data;
const salidasAgrupadas = [];
const lotesYaProcesados = new Set();

salidas.forEach(salida => {
  if (salida.es_lote && salida.lote_grupo_id && !lotesYaProcesados.has(salida.lote_grupo_id)) {
    const salidasDelLote = salidas.filter(s => s.lote_grupo_id === salida.lote_grupo_id);
    
    salidasAgrupadas.push({
      id: salida.lote_grupo_id,
      tipo: 'salida-lote',
      es_lote: true,
      lote_grupo_id: salida.lote_grupo_id,
      fecha: salida.fecha,
      departamento_id: salida.departamento_id,
      responsable: salida.responsable,
      observacion: salida.observacion,
      estado: salida.estado,
      usuario_solicitante: salida.usuario_solicitante,
      createdAt: salida.createdAt,
      motivo_rechazo: salida.motivo_rechazo,
      aprobado_por: salida.aprobado_por,
      fecha_aprobacion: salida.fecha_aprobacion,
      proyecto: salida.proyecto,
      almacen_origen: salida.almacen_origen,
      Departamento: salida.Departamento,
      AlmacenOrigenId: salida.AlmacenOrigenId,
      proyectoId: salida.proyectoId,
      items: salidasDelLote.map(s => ({
        id: s.id,
        material_codigo: s.material?.codigo || 'N/A',
        material_nombre: s.material?.nombre || 'Material desconocido',
        cantidad: s.cantidad,
        MaterialId: s.MaterialId,
        estado: s.estado
      })),
      cantidad_total: salidasDelLote.reduce((sum, s) => sum + s.cantidad, 0),
      cantidad_items: salidasDelLote.length
    });
    
    lotesYaProcesados.add(salida.lote_grupo_id);
  } 
  else if (!salida.es_lote || !salida.lote_grupo_id) {
    salidasAgrupadas.push({ ...salida, tipo: 'salida' });
  }
});

const todos = [...entradasAgrupadas, ...salidasAgrupadas];
    
    const itemsProcesados = todos.filter(
      item => item.estado === 'aprobada' || item.estado === 'rechazada'
    );
    
    setItems(itemsProcesados);
    setDepartamentos(departamentosRes.data);
    
  } catch (error) {
    console.error("❌ Error cargando historial:", error);
    setMensaje({ texto: "❌ Error al cargar historial", tipo: "error" });
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    cargarItems(); // <-- Llamar a la nueva función
  }, []);

  // 🔍 Filtrar items por estado y rango de fechas (ahora dinámico)
 const itemsFiltrados = () => {
  let resultado = items;

  // Filtrar por estado
  if (filtroEstado !== "todas") {
    resultado = resultado.filter(e => e.estado === filtroEstado);
  }

  // ✅ CORRECCIÓN: Filtrar por rango de fechas SIN conversión de Date
  resultado = resultado.filter(item => {
    // Entradas: filtrar por fecha_adquisicion (fecha del documento — DATE pura, sin zona horaria)
    // Salidas: filtrar por fecha_aprobacion
    const fechaBase = item.tipo === 'entrada'
      ? item.fecha_adquisicion
      : item.fecha_aprobacion;
    
    // Si no hay fecha, no mostrar el item
    if (!fechaBase) return false;
    
    // ✅ EXTRAER SOLO LA FECHA (YYYY-MM-DD) sin conversión de timezone
   const fechaItem = normalizarFecha(fechaBase);
if (!fechaItem) return false;
    
    // Comparar fechas como strings (YYYY-MM-DD funciona perfectamente así)
   return fechaItem >= fechaInicio && fechaItem <= fechaFin;
  });

  return resultado;
};

  const getEstadoBadge = (estado) => {
    switch (estado) {
      case "aprobada":
        return { bg: "#d1fae5", color: "#065f46", icon: "✅", texto: "APROBADA" };
      case "rechazada":
        return { bg: "#fee2e2", color: "#991b1b", icon: "❌", texto: "RECHAZADA" };
      default:
        return { bg: "#f3f4f6", color: "#374151", icon: "📋", texto: estado?.toUpperCase() || "N/A" };
    }
  };
  
 
const getTipoBadge = (tipo) => {
  if (tipo === 'entrada') {
    return { bg: "#dbeafe", color: "#1d4ed8", texto: "📥 ENTRADA" };
  } else if (tipo === 'entrada-lote') {
    return { bg: "#dcfce7", color: "#166534", texto: "📦 LOTE ENTRADA" };
  } else if (tipo === 'salida-lote') {
    return { bg: "#fecaca", color: "#991b1b", texto: "📦 LOTE SALIDA" };
  } else {
    return { bg: "#fee2e2", color: "#b91c1c", texto: "📤 SALIDA" };
  }
};

  const verDetalle = (item) => {
    setVerRechazados(false);
    setModalDetalle(item);
  };

  const cerrarModal = () => {
    setModalDetalle(null);
  };

  // 🖨️ Función para imprimir (AHORA DINÁMICA)
const imprimir = (item) => {
  if (item.tipo === 'entrada') {
    imprimirEntrada(item);
  } else if (item.tipo === 'entrada-lote') {
    imprimirLoteEntrada(item); // ✅ Nuevo
  } else if (item.tipo === 'salida-lote') {
    imprimirLoteCompleto(item);
  } else {
    imprimirSalida(item);
  }
};


  const imprimirEntrada = (entrada) => {
    const win = window.open("", "_blank");
    // ... (El mismo código de impresión de entrada que ya tenías)
    win.document.write(`
      <html>
        <head>
          <title>Comprobante de Entrada</title>
          <style>
            body { font-family: 'Arial', sans-serif; padding: 40px; max-width: 800px; margin: 0 auto; }
            .header { text-align: center; border-bottom: 3px solid #1e3a8a; padding-bottom: 20px; margin-bottom: 30px; }
            h1 { color: #1e3a8a; margin: 0; font-size: 28px; }
            .estado-badge { display: inline-block; background: #d1fae5; color: #065f46; padding: 8px 20px; border-radius: 20px; font-weight: bold; margin-top: 10px; }
            .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 30px 0; }
            .info-item { padding: 15px; background: #f8fafc; border-left: 4px solid #3b82f6; border-radius: 4px; }
            .info-label { font-size: 12px; color: #64748b; font-weight: bold; text-transform: uppercase; margin-bottom: 5px; }
            .info-value { font-size: 16px; color: #1e293b; font-weight: 600; }
            .total-section { background: #1e293b; color: white; padding: 20px; border-radius: 8px; text-align: center; margin: 30px 0; }
            .total-label { font-size: 14px; margin-bottom: 5px; }
            .total-value { font-size: 32px; font-weight: bold; }
            .firma-section { margin-top: 60px; padding-top: 20px; border-top: 1px solid #e2e8f0; }
            .firma-box { text-align: center; margin-top: 40px; }
            .firma-linea { border-top: 2px solid #1e293b; width: 300px; margin: 0 auto 10px; }
            .footer { text-align: center; margin-top: 40px; font-size: 12px; color: #64748b; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>📦 COMPROBANTE DE ENTRADA</h1>
            <span class="estado-badge">✅ APROBADA</span>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">Código</div>
              <div class="info-value">${entrada.codigo || entrada.material?.codigo}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Fecha</div>
              <div class="info-value">${ normalizarFecha(entrada.fecha_adquisicion)}</div>
            </div>
            <div class="info-item" style="grid-column: 1 / -1;">
              <div class="info-label">Material / Descripción</div>
              <div class="info-value">${entrada.descripcion || entrada.material?.nombre || 'N/A'}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Proveedor</div>
              <div class="info-value">${entrada.proveedor || "N/A"}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Nº Factura</div>
              <div class="info-value">${entrada.numero_factura || "N/A"}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Cantidad</div>
              <div class="info-value">${entrada.cantidad} ${entrada.unidad_medida || entrada.material?.unidad || 'unid'}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Costo Unitario</div>
              <div class="info-value">RD$ ${parseFloat(entrada.costo_unitario || 0).toFixed(2)}</div>
            </div>
          </div>
          <div class="total-section">
            <div class="total-label">VALOR TOTAL</div>
            <div class="total-value">RD$ ${parseFloat(entrada.valor_total || 0).toFixed(2)}</div>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">Fecha de Aprobación</div>
              <div class="info-value">${entrada.fecha_aprobacion  ? formatearFechaLegible(entrada.fecha_aprobacion) : 'N/A'}</div>

            </div>
            <div class="info-item">
              <div class="info-label">Aprobado por</div>
              <div class="info-value">${entrada.aprobado_por || "Sistema"}</div>
            </div>
          </div>
          <div class="firma-section">
            <div class="firma-box">
              <div class="firma-linea"></div>
              <div><strong>Firma y Sello</strong></div>
              <div style="font-size: 12px; color: #64748b; margin-top: 5px;">Almacenero / Encargado</div>
            </div>
          </div>
          <div class="footer">
        
          </div>
        </body>
      </html>
    `);
    win.print();
    win.close();
  };
// ✅ FUNCIÓN PARA IMPRIMIR LOTE DE ENTRADAS
const imprimirLoteEntrada = (lote) => {
  if (!lote.items || lote.items.length === 0) {
    alert('⚠️ Este lote no tiene materiales');
    return;
  }

  const win = window.open("", "_blank");
  
  if (!win) {
    alert('⚠️ El navegador bloqueó la ventana emergente.');
    return;
  }

  win.document.write(`
    <html>
      <head>
        <title>Comprobante de Entrada - Lote</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 40px; max-width: 900px; margin: 0 auto; }
          .header { text-align: center; border-bottom: 3px solid #1d4ed8; padding-bottom: 20px; margin-bottom: 30px; }
          h1 { color: #1d4ed8; margin: 0; font-size: 28px; }
          .info-box { background: #f8fafc; padding: 15px; border-radius: 8px; margin-bottom: 15px; border-left: 4px solid #3b82f6; }
          .info-label { font-size: 12px; color: #64748b; font-weight: bold; text-transform: uppercase; }
          .info-value { font-size: 16px; color: #1e293b; font-weight: 600; margin-top: 5px; }
          table { width: 100%; border-collapse: collapse; margin: 25px 0; }
          th { background: #1e293b; color: white; padding: 12px 8px; text-align: left; font-size: 13px; }
          td { padding: 10px 8px; border-bottom: 1px solid #e2e8f0; font-size: 13px; }
          tr:hover { background: #f8fafc; }
          .total-row { background: #f8fafc; font-weight: bold; }
          .firma-section { margin-top: 60px; padding-top: 20px; border-top: 1px solid #e2e8f0; display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
          .firma-box { text-align: center; margin-top: 40px; }
          .firma-linea { border-top: 2px solid #1e293b; width: 300px; margin: 0 auto 10px; }
          .footer { text-align: center; margin-top: 40px; font-size: 12px; color: #64748b; }
          @media print { body { padding: 20px; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>📦 COMPROBANTE DE ENTRADA - LOTE</h1>
          <p style="margin: 10px 0 0 0; color: #64748b; font-size: 12px;">${lote.lote_entrada_id}</p>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
          <div class="info-box">
            <div class="info-label">Factura:</div>
            <div class="info-value">${lote.numero_factura || 'N/A'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Proveedor:</div>
            <div class="info-value">${lote.proveedor || 'N/A'}</div>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
          <div class="info-box">
            <div class="info-label">Responsable:</div>
            <div class="info-value">${lote.responsable || 'N/A'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Fecha:</div>
            <div class="info-value">${normalizarFecha(lote.fecha_adquisicion)}</div>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Material</th>
              <th style="text-align: center;">Cantidad</th>
              <th style="text-align: right;">Costo Unit.</th>
              <th style="text-align: right;">Valor Total</th>
            </tr>
          </thead>
          <tbody>
            ${lote.items.map(item => `
              <tr>
                <td><strong>${item.material_codigo}</strong></td>
                <td>${item.material_nombre}</td>
                <td style="text-align: center;"><strong>${item.cantidad}</strong></td>
                <td style="text-align: right;">RD$ ${parseFloat(item.costo_unitario || 0).toFixed(2)}</td>
                <td style="text-align: right;">RD$ ${parseFloat(item.valor_total || 0).toFixed(2)}</td>
              </tr>
            `).join('')}
            <tr class="total-row">
              <td colspan="2" style="text-align: right;">TOTAL DE ITEMS:</td>
              <td style="text-align: center;">${lote.cantidad_items}</td>
              <td></td>
              <td></td>
            </tr>
            <tr class="total-row">
              <td colspan="2" style="text-align: right;">TOTAL UNIDADES:</td>
              <td style="text-align: center;">${lote.cantidad_total}</td>
              <td></td>
              <td></td>
            </tr>
            <tr class="total-row">
              <td colspan="4" style="text-align: right;">VALOR TOTAL:</td>
              <td style="text-align: right;">RD$ ${parseFloat(lote.valor_total || 0).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        <div class="firma-section">
          <div class="firma-box">
            <div class="firma-linea"></div>
            <strong>Firma (Recibido por)</strong><br>
            <span style="font-size: 12px; color: #64748b;">Almacenero / Encargado</span>
          </div>
          <div class="firma-box">
            <div class="firma-linea"></div>
            <strong>Firma (Entregado por)</strong><br>
            <span style="font-size: 12px; color: #64748b;">Proveedor</span>
          </div>
        </div>

        <div class="footer">
          <p>Sistema eFIT - Gestión de Inventario</p>
          <p>Fecha de impresión: ${new Date().toLocaleString('es-DO')}</p>
        </div>

        <script>
          window.onload = () => window.print();
        </script>
      </body>
    </html>
  `);
  
  win.document.close();
};
// 📄 COMPROBANTE DE SALIDA — CORREGIDO
const imprimirSalida = (salida) => {
  const win = window.open("", "_blank");

  win.document.write(`
    <html>
      <head>
        <title>Comprobante de Salida</title>
        <style>
          body { font-family: 'Arial', sans-serif; padding: 40px; max-width: 800px; margin: 0 auto; }
          .header { text-align: center; border-bottom: 3px solid #b91c1c; padding-bottom: 20px; margin-bottom: 30px; }
          h1 { color: #b91c1c; margin: 0; font-size: 28px; }
          .estado-badge { display: inline-block; background: #d1fae5; color: #065f46; padding: 8px 20px; border-radius: 20px; font-weight: bold; margin-top: 10px; }
          .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin: 30px 0; }
          .info-item { padding: 15px; background: #f8fafc; border-left: 4px solid #ef4444; border-radius: 4px; }
          .info-label { font-size: 12px; color: #64748b; font-weight: bold; text-transform: uppercase; margin-bottom: 5px; }
          .info-value { font-size: 16px; color: #1e293b; font-weight: 600; }
          .firma-section { margin-top: 60px; padding-top: 20px; border-top: 1px solid #e2e8f0; display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
          .firma-box { text-align: center; margin-top: 40px; }
          .firma-linea { border-top: 2px solid #1e293b; width: 300px; margin: 0 auto 10px; }
          .footer { text-align: center; margin-top: 40px; font-size: 12px; color: #64748b; }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>📤 COMPROBANTE DE SALIDA</h1>
          <span class="estado-badge">✅ APROBADA</span>
        </div>

        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Código</div>
            <div class="info-value">${salida.material?.codigo || 'N/A'}</div>
          </div>

          <div class="info-item">
            <div class="info-label">Fecha</div>
            <div class="info-value">${(salida.fecha)}</div>
          </div>

          <div class="info-item" style="grid-column: 1 / -1;">
            <div class="info-label">Material / Descripción</div>
            <div class="info-value">${salida.material?.nombre || 'N/A'}</div>
          </div>

          <div class="info-item">
            <div class="info-label">Destino</div>
            <div class="info-value">${salida.destino || "N/A"}</div>
          </div>

          <div class="info-item">
            <div class="info-label">Cantidad</div>
            <div class="info-value">${salida.cantidad} ${salida.material?.unidad || 'unid'}</div>
          </div>

          <div class="info-item" style="grid-column: 1 / -1;">
            <div class="info-label">Observación</div>
            <div class="info-value">${salida.observacion || "Ninguna"}</div>
          </div>
        </div>

        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Responsable (Solicitante)</div>
            <div class="info-value">${salida.usuario_solicitante || salida.responsable || "N/A"}</div>
          </div>

          <div class="info-item">
            <div class="info-label">Fecha de Aprobación</div>
            <div class="info-value">
             ${salida.fecha_aprobacion  ? formatearFechaLegible(salida.fecha_aprobacion) : 'N/A'}

            </div>
          </div>
        </div>

        <div class="firma-section">
          <div class="firma-box">
            <div class="firma-linea"></div>
            <div><strong>Firma (Recibido por)</strong></div>
            <div style="font-size: 12px; color: #64748b; margin-top: 5px;">${salida.destino || ''}</div>
          </div>

          <div class="firma-box">
            <div class="firma-linea"></div>
            <div><strong>Firma (Entregado por)</strong></div>
            <div style="font-size: 12px; color: #64748b; margin-top: 5px;">Almacenero / Encargado</div>
          </div>
        </div>

        <div class="footer">
   
        </div>
      </body>
    </html>
  `);

  win.print();
  win.close();
};
const imprimirLoteCompleto = (lote) => {
  if (!lote.items || lote.items.length === 0) {
    alert('⚠️ Este lote no tiene materiales');
    return;
  }

  const departamento = getNombreDepartamento(lote.departamento_id);
  const proyecto = lote.proyecto?.nombre || 'Sin proyecto asignado';

  const win = window.open("", "_blank");
  
  if (!win) {
    alert('⚠️ El navegador bloqueó la ventana emergente.');
    return;
  }

  win.document.write(`
    <html>
      <head>
        <title>Comprobante de Salida - Lote</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 40px; max-width: 900px; margin: 0 auto; }
          .header { text-align: center; border-bottom: 3px solid #b91c1c; padding-bottom: 20px; margin-bottom: 30px; }
          h1 { color: #b91c1c; margin: 0; font-size: 28px; }
          .info-box { background: #f8fafc; padding: 15px; border-radius: 8px; margin-bottom: 15px; border-left: 4px solid #ef4444; }
          .info-label { font-size: 12px; color: #64748b; font-weight: bold; text-transform: uppercase; }
          .info-value { font-size: 16px; color: #1e293b; font-weight: 600; margin-top: 5px; }
          .proyecto-box { background: #dbeafe; color: #1d4ed8; padding: 15px; border-radius: 8px; margin-bottom: 15px; border-left: 4px solid #3b82f6; }
          table { width: 100%; border-collapse: collapse; margin: 25px 0; }
          th { background: #1e293b; color: white; padding: 12px 8px; text-align: left; font-size: 13px; }
          td { padding: 10px 8px; border-bottom: 1px solid #e2e8f0; font-size: 13px; }
          tr:hover { background: #f8fafc; }
          .total-row { background: #f8fafc; font-weight: bold; }
          .firma-section { margin-top: 60px; padding-top: 20px; border-top: 1px solid #e2e8f0; display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
          .firma-box { text-align: center; margin-top: 40px; }
          .firma-linea { border-top: 2px solid #1e293b; width: 300px; margin: 0 auto 10px; }
          .footer { text-align: center; margin-top: 40px; font-size: 12px; color: #64748b; }
          @media print { body { padding: 20px; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>📦 COMPROBANTE DE SALIDA - LOTE</h1>
          <p style="margin: 10px 0 0 0; color: #64748b; font-size: 12px;">${lote.lote_grupo_id}</p>
        </div>

        ${lote.proyecto ? `
          <div class="proyecto-box">
            <div class="info-label">🏗️ Proyecto:</div>
            <div class="info-value" style="color: #1d4ed8;">${proyecto}</div>
          </div>
        ` : ''}

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
          <div class="info-box">
            <div class="info-label">Almacén:</div>
            <div class="info-value">${lote.almacen_origen?.nombre || 'N/A'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Destino:</div>
            <div class="info-value">${departamento}</div>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
          <div class="info-box">
            <div class="info-label">Responsable:</div>
            <div class="info-value">${lote.responsable || 'N/A'}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Fecha:</div>
            <div class="info-value">${ normalizarFecha (lote.fecha)}</div>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Material</th>
              <th style="text-align: center;">Cantidad</th>
            </tr>
          </thead>
          <tbody>
           ${lote.items
  .filter(item => item.estado === 'aprobada')  // ✅ FILTRAR SOLO APROBADOS
  .map(item => `
    <tr>
      <td><strong>${item.material_codigo}</strong></td>
      <td>${item.material_nombre}</td>
      <td style="text-align: center;"><strong>${item.cantidad}</strong></td>
    </tr>
  `).join('')}
           <tr class="total-row">
  <td colspan="2" style="text-align: right;">TOTAL DE ITEMS:</td>
  <td style="text-align: center;">${lote.items.filter(i => i.estado === 'aprobada').length}</td>
</tr>
<tr class="total-row">
  <td colspan="2" style="text-align: right;">TOTAL UNIDADES:</td>
  <td style="text-align: center;">${lote.items.filter(i => i.estado === 'aprobada').reduce((sum, i) => sum + i.cantidad, 0)}</td>
</tr>
          </tbody>
        </table>

        ${lote.observacion ? `
          <div class="info-box">
            <div class="info-label">Observación:</div>
            <div class="info-value">${lote.observacion}</div>
          </div>
        ` : ''}

        <div class="firma-section">
          <div class="firma-box">
            <div class="firma-linea"></div>
            <div><strong>Firma (Recibido por)</strong></div>
            <div style="font-size: 12px; color: #64748b; margin-top: 5px;">${departamento}</div>
          </div>
          <div class="firma-box">
            <div class="firma-linea"></div>
            <div><strong>Firma (Entregado por)</strong></div>
            <div style="font-size: 12px; color: #64748b; margin-top: 5px;">Almacenero</div>
          </div>
        </div>

        <div class="footer">
          <p>Generado: ${new Date().toLocaleDateString('es-DO', {
            year: 'numeric', month: 'long', day: 'numeric'
          })} - ${new Date().toLocaleTimeString('es-DO')}</p>
        </div>

        <script>
          window.onload = function() { window.print(); };
        </script>
      </body>
    </html>
  `);
  win.document.close();
};

  // Calcular estadísticas (actualizado)
  const itemsFiltradosLista = itemsFiltrados();
  
  const estadisticas = {
    total: itemsFiltradosLista.length,
    aprobadas: itemsFiltradosLista.filter(e => e.estado === "aprobada").length,
    rechazadas: itemsFiltradosLista.filter(e => e.estado === "rechazada").length,
    // Sumar solo el valor de las entradas
    valorTotal: itemsFiltradosLista
      .filter(e => e.tipo === 'entrada' && e.estado === "aprobada")
      .reduce((sum, e) => sum + parseFloat(e.valor_total || 0), 0),
  };

  return (
    <div style={styles.container}>
      {/* Header (título actualizado) */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>📚 Historial de Movimientos</h1>
          <p style={styles.subtitle}>Registro de entradas y salidas aprobadas y rechazadas</p>
        </div>
      </div>

      {/* Estadísticas (título actualizado) */}
      <div style={styles.statsContainer}>
        <div style={{...styles.statCard, borderLeft: "4px solid #6366f1"}}>
          <div style={styles.statIcon}>📦</div>
          <div>
            <div style={styles.statValue}>{estadisticas.total}</div>
            <div style={styles.statLabel}>Total en Rango</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: "4px solid #10b981"}}>
          <div style={styles.statIcon}>✅</div>
          <div>
            <div style={styles.statValue}>{estadisticas.aprobadas}</div>
            <div style={styles.statLabel}>Aprobadas</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: "4px solid #ef4444"}}>
          <div style={styles.statIcon}>❌</div>
          <div>
            <div style={styles.statValue}>{estadisticas.rechazadas}</div>
            <div style={styles.statLabel}>Rechazadas</div>
          </div>
        </div>

        <div style={{...styles.statCard, borderLeft: "4px solid #8b5cf6"}}>
          <div style={styles.statIcon}>💰</div>
          <div>
            <div style={styles.statValue}>RD$ {estadisticas.valorTotal.toFixed(2)}</div>
            <div style={styles.statLabel}>Valor Aprobado (Entradas)</div>
          </div>
        </div>
      </div>

      {/* Filtros (sin cambios, ya son funcionales) */}
      <div style={styles.filtrosCard}>
        {/* ... (mismo código de filtros que ya tenías) ... */}
         <div style={styles.filtrosHeader}>
          <h3 style={styles.filtrosTitle}>🔍 Filtros</h3>
        </div>
        
        <div style={styles.filtrosBody}>
          {/* Filtro de Estado */}
          <div style={styles.filtroGroup}>
            <label style={styles.filtroLabel}>Estado:</label>
            <div style={styles.filtroButtonGroup}>
              <button 
                style={{
                  ...styles.filtroBtn,
                  ...(filtroEstado === "todas" && styles.filtroBtnActive)
                }}
                onClick={() => setFiltroEstado("todas")}
              >
                Todas
              </button>
              <button 
                style={{
                  ...styles.filtroBtn,
                  ...(filtroEstado === "aprobada" && styles.filtroBtnActive)
                }}
                onClick={() => setFiltroEstado("aprobada")}
              >
                ✅ Aprobadas
              </button>
              <button 
                style={{
                  ...styles.filtroBtn,
                  ...(filtroEstado === "rechazada" && styles.filtroBtnActive)
                }}
                onClick={() => setFiltroEstado("rechazada")}
              >
                ❌ Rechazadas
              </button>
            </div>
          </div>

          {/* Filtro de Rango de Fechas */}
          <div style={styles.filtroGroup}>
            <label style={styles.filtroLabel}>Rango de Fechas:</label>
            <div style={styles.fechaInputGroup}>
              <div style={styles.fechaInput}>
                <label style={styles.fechaSubLabel}>Desde:</label>
                <input
                  type="date"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                  style={styles.dateInput}
                />
              </div>
              <div style={styles.fechaInput}>
                <label style={styles.fechaSubLabel}>Hasta:</label>
                <input
                  type="date"
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                  style={styles.dateInput}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mensaje */}
      {mensaje.texto && (
        <div style={{
          ...styles.message,
          ...(mensaje.tipo === "success" ? styles.messageSuccess : styles.messageError)
        }}>
          {mensaje.texto}
        </div>
      )}

      {/* Tabla (actualizada) */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>
          📋 Movimientos Registrados ({itemsFiltradosLista.length})
        </h3>

        {loading ? (
          <div style={styles.loadingMessage}>⏳ Cargando historial...</div>
        ) : itemsFiltradosLista.length === 0 ? (
          <div style={styles.emptyMessage}>
            🔭 No hay movimientos en el rango de fechas seleccionado
            <br />
            <small>Ajusta los filtros para ver más resultados</small>
          </div>
        ) : (
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeaderRow}>
                  <th style={styles.th}>Tipo</th>
                  <th style={styles.th}>Fecha</th>
                  <th style={styles.th}>Código</th>
                  <th style={styles.th}>Material</th>
                  <th style={styles.th}>Proveedor / Destino</th> 
                  <th style={styles.th}>Cantidad</th>
                  <th style={styles.th}>Costo Unit.</th> 
                  <th style={styles.th}>Valor Total</th> 
                  <th style={styles.th}>Estado</th>
                  <th style={styles.th}>Acciones</th>
                </tr>
              </thead>
             <tbody>
  {itemsFiltradosLista.map((item) => {
    const estadoBadge = getEstadoBadge(item.estado);
    const tipoBadge = getTipoBadge(item.tipo);
    return (
      <tr key={`${item.tipo}-${item.id}`} style={styles.tr}>
        <td style={styles.td}>
          <span style={{
            ...styles.badge,
            background: tipoBadge.bg,
            color: tipoBadge.color
          }}>
            {tipoBadge.texto}
          </span>
        </td>
<td style={styles.td}>
  {/* ✅ Usar normalizarFecha para evitar saltos de zona horaria */}
 {normalizarFecha(
  (item.tipo === 'entrada' || item.tipo === 'entrada-lote')
    ? item.fecha_adquisicion 
    : (item.fecha_aprobacion || item.fecha)
)}
</td>
        
        {/* ✅ CÓDIGO - ACTUALIZADO PARA LOTES */}
        <td style={styles.td}>
          <strong>
            {item.tipo === 'salida-lote' 
  ? item.lote_grupo_id.substring(0, 18) + '...'
  : item.tipo === 'entrada-lote'
  ? item.numero_factura || '—'
  : (item.codigo || item.material?.codigo || '—')}
          </strong>
        </td>
        
        {/* ✅ MATERIAL - ACTUALIZADO PARA LOTES */}
        <td style={styles.td}>
          {item.tipo === 'salida-lote'
  ? `Lote de ${item.cantidad_items} materiales`
  : item.tipo === 'entrada-lote'
  ? `Lote de ${item.cantidad_items} materiales`
  : (item.descripcion || item.material?.nombre || '—')}
        </td>
        
        {/* ✅ PROVEEDOR/DESTINO - ACTUALIZADO PARA LOTES */}
        <td style={styles.td}>
         {(item.tipo === 'entrada' || item.tipo === 'entrada-lote')
  ? (item.proveedor || '—') 
  : (item.tipo === 'salida-lote' || item.departamento_id)
    ? getNombreDepartamento(item.departamento_id)
    : (item.destino || '—')}
        </td>
        
        {/* ✅ CANTIDAD - ACTUALIZADO PARA LOTES */}
        <td style={styles.tdNum}>
         {(item.tipo === 'salida-lote' || item.tipo === 'entrada-lote')
  ? `${item.cantidad_items} items (${item.cantidad_total} unid.)` 
  : item.cantidad}
        </td>
        
        <td style={styles.tdNum}>
          {/* Muestra el costo siempre, sea entrada o salida */}
          RD${parseFloat(item.costo_unitario || 0).toFixed(2)}
        </td>
        
        <td style={styles.tdNum}>
          <strong>
            {/* Muestra el valor siempre, sea entrada o salida */}
            RD${parseFloat(item.valor_total || 0).toFixed(2)}
          </strong>
        </td>
        
        <td style={styles.td}>
          <span style={{
            ...styles.badge,
            background: estadoBadge.bg,
            color: estadoBadge.color
          }}>
            {estadoBadge.icon} {estadoBadge.texto}
          </span>
        </td>
        
        {/* ✅ ACCIONES - ACTUALIZADO CON BOTÓN PARA LOTES */}
        <td style={styles.tdActions}>
          <button 
            style={styles.btnVer}
            onClick={() => verDetalle(item)}
          >
            👁️ Ver
          </button>
          
          {/* Botón imprimir - DIFERENCIADO POR TIPO */}
          {item.estado === "aprobada" && item.tipo === 'salida-lote' && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                imprimirLoteCompleto(item);
              }}
              style={styles.btnImprimir}
            >
              🖨️
            </button>
          )}
          
          {item.estado === "aprobada" && item.tipo !== 'salida-lote' && (
            <button
              onClick={() => imprimir(item)}
              style={styles.btnImprimir}
            >
              🖨️
            </button>
          )}
        </td>
      </tr>
    );
  })}
</tbody>
            </table>
          </div>
        )}
      </div>

   {/* Modal de Detalle (actualizado CON SOPORTE PARA LOTES) */}
{modalDetalle && (
  <div style={styles.modalOverlay} onClick={cerrarModal}>
    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
      <div style={styles.modalHeader}>
        <h2 style={styles.modalTitle}>
         {modalDetalle.tipo === 'entrada' 
  ? '📋 Detalle de Entrada' 
  : modalDetalle.tipo === 'entrada-lote'
  ? '📦 Detalle de Lote de Entradas'
  : modalDetalle.tipo === 'salida-lote'
    ? '📦 Detalle de Lote de Salidas'
    : '📤 Detalle de Salida'}
        </h2>
        <button style={styles.btnCerrar} onClick={cerrarModal}>✕</button>
      </div>

      <div style={styles.modalBody}>
        <div style={styles.detalleGrid}>
          <div style={styles.detalleItem}>
            <span style={styles.detalleLabel}>Tipo:</span>
            <span style={styles.detalleValue}>
              {(() => {
                const badge = getTipoBadge(modalDetalle.tipo);
                return (
                  <span style={{
                    ...styles.badge,
                    background: badge.bg,
                    color: badge.color
                  }}>
                    {badge.texto}
                  </span>
                );
              })()}
            </span>
          </div>
{/* ✅ SI ES LOTE DE ENTRADAS */}
{modalDetalle.tipo === 'entrada-lote' && (
  <>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Factura</span>
      <span style={styles.detalleValue}>{modalDetalle.numero_factura || 'N/A'}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Proveedor</span>
      <span style={styles.detalleValue}>{modalDetalle.proveedor || 'N/A'}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Total Materiales</span>
      <span style={styles.detalleValue}>{modalDetalle.cantidad_items}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Cantidad Total</span>
      <span style={styles.detalleValue}>{modalDetalle.cantidad_total}</span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Valor Total</span>
      <span style={styles.detalleValue}>
        RD$ {parseFloat(modalDetalle.valor_total || 0).toFixed(2)}
      </span>
    </div>
    <div style={styles.detalleItem}>
      <span style={styles.detalleLabel}>Fecha</span>
      <span style={styles.detalleValue}>
        {normalizarFecha(modalDetalle.fecha_adquisicion)}
      </span>
    </div>

    {/* Tabla de materiales del lote */}
    <div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
      <span style={styles.detalleLabel}>Materiales del Lote:</span>
      <div style={{ marginTop: '10px' }}>
        <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              <th style={{ 
                padding: '8px', 
                textAlign: 'left', 
                borderBottom: '2px solid #e2e8f0',
                fontWeight: '600'
              }}>Código</th>
              <th style={{ 
                padding: '8px', 
                textAlign: 'left', 
                borderBottom: '2px solid #e2e8f0',
                fontWeight: '600'
              }}>Material</th>
              <th style={{ 
                padding: '8px', 
                textAlign: 'right', 
                borderBottom: '2px solid #e2e8f0',
                fontWeight: '600'
              }}>Cantidad</th>
              <th style={{ 
                padding: '8px', 
                textAlign: 'right', 
                borderBottom: '2px solid #e2e8f0',
                fontWeight: '600'
              }}>Costo Unit.</th>
              <th style={{ 
                padding: '8px', 
                textAlign: 'right', 
                borderBottom: '2px solid #e2e8f0',
                fontWeight: '600'
              }}>Valor Total</th>
            </tr>
          </thead>
          <tbody>
            {modalDetalle.items?.map((item, idx) => (
              <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                <td style={{ padding: '8px' }}>
                  <strong>{item.material_codigo}</strong>
                </td>
                <td style={{ padding: '8px' }}>{item.material_nombre}</td>
                <td style={{ padding: '8px', textAlign: 'right' }}>
                  <strong>{item.cantidad}</strong>
                </td>
                <td style={{ padding: '8px', textAlign: 'right' }}>
                  RD$ {parseFloat(item.costo_unitario || 0).toFixed(2)}
                </td>
                <td style={{ padding: '8px', textAlign: 'right' }}>
                  RD$ {parseFloat(item.valor_total || 0).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
)}
          {/* ============================================ */}
          {/* SECCIÓN PARA ENTRADAS */}
          {/* ============================================ */}
          {modalDetalle.tipo === 'entrada' && (
            <>
              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Código:</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.codigo || modalDetalle.material?.codigo}
                </span>
              </div>

              <div style={{ ...styles.detalleItem, gridColumn: '1 / -1' }}>
                <span style={styles.detalleLabel}>Material:</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.descripcion || modalDetalle.material?.nombre}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Proveedor:</span>
                <span style={styles.detalleValue}>{modalDetalle.proveedor || 'N/A'}</span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Nº Factura:</span>
                <span style={styles.detalleValue}>{modalDetalle.numero_factura || 'N/A'}</span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Fecha:</span>
                <span style={styles.detalleValue}>
                  { normalizarFecha (modalDetalle.fecha_adquisicion)}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Cantidad:</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.cantidad} {modalDetalle.unidad_medida || modalDetalle.material?.unidad}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Costo Unitario:</span>
                <span style={styles.detalleValue}>
                  RD${parseFloat(modalDetalle.costo_unitario || 0).toFixed(2)}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Valor Total:</span>
                <span style={{...styles.detalleValue, fontWeight: '700', fontSize: '18px'}}>
                  RD${parseFloat(modalDetalle.valor_total || 0).toFixed(2)}
                </span>
              </div>
            </>
          )}

          {/* ============================================ */}
          {/* SECCIÓN PARA LOTES DE SALIDA */}
          {/* ============================================ */}
          {modalDetalle.tipo === 'salida-lote' && (
            <>
              {/* Proyecto con estilo azul */}
              {modalDetalle.proyecto && (
                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>Proyecto:</span>
                  <span style={{
                    ...styles.detalleValue,
                    background: '#dbeafe',
                    color: '#1d4ed8',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    fontWeight: '600',
                    display: 'inline-block'
                  }}>
                    🏗️ {modalDetalle.proyecto.nombre}
                  </span>
                </div>
              )}

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Almacén:</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.almacen_origen?.nombre || '—'}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Departamento:</span>
                <span style={styles.detalleValue}>
                  {getNombreDepartamento(modalDetalle.departamento_id)}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Responsable:</span>
                <span style={styles.detalleValue}>{modalDetalle.responsable || "—"}</span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Fecha:</span>
                <span style={styles.detalleValue}>
                  { normalizarFecha(modalDetalle.fecha)}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Total de Materiales:</span>
                <span style={styles.detalleValue}>{modalDetalle.cantidad_items} items</span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Cantidad Total:</span>
                <span style={styles.detalleValue}>{modalDetalle.cantidad_total} unidades</span>
              </div>

              <div style={styles.detalleItem}>
  <span style={styles.detalleLabel}>ID del Lote:</span>
  <span style={{...styles.detalleValue, fontSize: '11px'}}>
    {modalDetalle.lote_grupo_id}
  </span>
</div>

              {/* Tabla de materiales del lote */}
              <div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
                <span style={styles.detalleLabel}>Materiales del Lote:</span>
                <div style={{ marginTop: '10px' }}>
 <div style={{ marginBottom: '15px', textAlign: 'right' }}>
  <button
    style={{
      padding: '8px 16px',
      background: verRechazados 
        ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' 
        : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '600',
      cursor: 'pointer',
      boxShadow: verRechazados
        ? '0 2px 8px rgba(16, 185, 129, 0.3)'
        : '0 2px 8px rgba(239, 68, 68, 0.3)',
      transition: 'all 0.2s',
    }}
    onMouseEnter={(e) => {
      e.target.style.transform = 'translateY(-2px)';
      e.target.style.boxShadow = verRechazados
        ? '0 4px 12px rgba(16, 185, 129, 0.4)'
        : '0 4px 12px rgba(239, 68, 68, 0.4)';
    }}
    onMouseLeave={(e) => {
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = verRechazados
        ? '0 2px 8px rgba(16, 185, 129, 0.3)'
        : '0 2px 8px rgba(239, 68, 68, 0.3)';
    }}
    onClick={() => setVerRechazados(!verRechazados)}
  >
    {verRechazados ? '👁 Ver Aprobados' : '🚫 Ver Rechazados'}
  </button>
</div>
                  <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f8fafc' }}>
                        <th style={{ 
                          padding: '8px', 
                          textAlign: 'left', 
                          borderBottom: '2px solid #e2e8f0',
                          fontWeight: '600'
                        }}>Código</th>
                        <th style={{ 
                          padding: '8px', 
                          textAlign: 'left', 
                          borderBottom: '2px solid #e2e8f0',
                          fontWeight: '600'
                        }}>Material</th>
                        <th style={{ 
                          padding: '8px', 
                          textAlign: 'right', 
                          borderBottom: '2px solid #e2e8f0',
                          fontWeight: '600'
                        }}>Cantidad</th>
                      </tr>
                    </thead>
                    <tbody>
  {modalDetalle.items
    ?.filter(item =>
      verRechazados
        ? item.estado === 'rechazada'
        : item.estado === 'aprobada'
    )
    .map((item, idx) => (
      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
        <td style={{ padding: '8px' }}>
          <strong>{item.material_codigo}</strong>
        </td>
        <td style={{ padding: '8px' }}>{item.material_nombre}</td>
        <td style={{ padding: '8px', textAlign: 'right' }}>
          <strong>{item.cantidad}</strong>
        </td>
      </tr>
    ))}
</tbody>

                  </table>
                </div>
              </div>

              {modalDetalle.observacion && (
                <div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
                  <span style={styles.detalleLabel}>Observaciones:</span>
                  <span style={styles.detalleValue}>{modalDetalle.observacion}</span>
                </div>
              )}
            </>
          )}

          {/* ============================================ */}
          {/* SECCIÓN PARA SALIDAS NORMALES */}
          {/* ============================================ */}
          {modalDetalle.tipo === 'salida' && (
            <>
              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Código:</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.codigo || modalDetalle.material?.codigo}
                </span>
              </div>

              <div style={{ ...styles.detalleItem, gridColumn: '1 / -1' }}>
                <span style={styles.detalleLabel}>Material:</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.descripcion || modalDetalle.material?.nombre}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Destino:</span>
                <span style={styles.detalleValue}>{modalDetalle.destino || 'N/A'}</span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Responsable (Solicitante):</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.usuario_solicitante || modalDetalle.responsable || 'N/A'}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Fecha:</span>
                <span style={styles.detalleValue}>
                  { normalizarFecha(modalDetalle.fecha)}
                </span>
              </div>

              <div style={styles.detalleItem}>
                <span style={styles.detalleLabel}>Cantidad:</span>
                <span style={styles.detalleValue}>
                  {modalDetalle.cantidad} {modalDetalle.unidad_medida || modalDetalle.material?.unidad}
                </span>
              </div>
            </>
          )}

          {/* ============================================ */}
          {/* CAMPOS COMUNES PARA TODOS */}
          {/* ============================================ */}
          <div style={styles.detalleItem}>
            <span style={styles.detalleLabel}>Estado:</span>
            <span style={styles.detalleValue}>
              {(() => {
                const badge = getEstadoBadge(modalDetalle.estado);
                return (
                  <span style={{
                    ...styles.badge,
                    background: badge.bg,
                    color: badge.color
                  }}>
                    {badge.icon} {badge.texto}
                  </span>
                );
              })()}
            </span>
          </div>

   {modalDetalle.fecha_aprobacion && (
  <div style={styles.detalleItem}>
    <span style={styles.detalleLabel}>Fecha Aprobación/Rechazo:</span>
    <span style={styles.detalleValue}>
      {/* 🛡️ Forzamos la extracción de los primeros 10 caracteres para que NO salte de día */}
      {formatearFechaLegible(String(modalDetalle.fecha_aprobacion).substring(0, 10))}
    </span>
  </div>
)}

          {modalDetalle.aprobado_por && (
            <div style={styles.detalleItem}>
              <span style={styles.detalleLabel}>Procesado por:</span>
              <span style={styles.detalleValue}>{modalDetalle.aprobado_por}</span>
            </div>
          )}

          {modalDetalle.motivo_rechazo && (
            <div style={{...styles.detalleItem, gridColumn: '1 / -1'}}>
              <span style={styles.detalleLabel}>Motivo de Rechazo:</span>
              <span style={{...styles.detalleValue, color: '#991b1b', fontWeight: '600'}}>
                {modalDetalle.motivo_rechazo}
              </span>
            </div>
          )}
        </div>

        {/* Botones de acción */}
        {modalDetalle.estado === "aprobada" && (
          <div style={styles.modalActions}>
            {modalDetalle.tipo === 'salida-lote' ? (
              <button 
                style={styles.btnModalImprimir}
                onClick={() => imprimirLoteCompleto(modalDetalle)}
              >
                🖨️ Imprimir Lote Completo
              </button>
            ) : (
              <button 
                style={styles.btnModalImprimir}
                onClick={() => imprimir(modalDetalle)}
              >
                🖨️ Imprimir Comprobante
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  </div>
)}
    </div>
  );
};

// ... (Pega todos tus estilos aquí)
const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    padding: '20px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    marginBottom: '25px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: '0',
  },
  statsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '25px',
  },
  statCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  statIcon: {
    fontSize: '32px',
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
  },
  statLabel: {
    fontSize: '12px',
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  filtrosCard: {
    background: 'white',
    borderRadius: '12px',
    marginBottom: '25px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
    overflow: 'hidden',
  },
  filtrosHeader: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '15px 20px',
  },
  filtrosTitle: {
    margin: 0,
    fontSize: '16px',
    fontWeight: '600',
    color: 'white',
  },
  filtrosBody: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  filtroGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  filtroLabel: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  filtroButtonGroup: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  filtroBtn: {
    padding: '10px 20px',
    background: 'white',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#64748b',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  filtroBtnActive: {
    background: '#3b82f6',
    borderColor: '#3b82f6',
    color: 'white',
  },
  fechaInputGroup: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '15px',
  },
  fechaInput: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  fechaSubLabel: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#64748b',
  },
  dateInput: {
    padding: '10px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '14px',
    color: '#1e293b',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  message: {
    marginBottom: '20px',
    padding: '12px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
  },
  messageSuccess: {
    background: '#d1fae5',
    color: '#065f46',
    border: '1px solid #10b981',
  },
  messageError: {
    background: '#fee2e2',
    color: '#991b1b',
    border: '1px solid #ef4444',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '30px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 20px 0',
  },
  loadingMessage: {
    textAlign: 'center',
    padding: '40px',
    fontSize: '16px',
    color: '#64748b',
  },
  emptyMessage: {
    textAlign: 'center',
    padding: '40px',
    fontSize: '16px',
    color: '#64748b',
    background: '#f8fafc',
    borderRadius: '8px',
    lineHeight: '1.8',
  },
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
  },
  tableHeaderRow: {
    background: '#1e293b',
    color: 'white',
  },
  th: {
    padding: '12px 8px',
    textAlign: 'left',
    fontWeight: '600',
    borderBottom: '2px solid #cbd5e1',
  },
  tr: {
    borderBottom: '1px solid #e2e8f0',
    transition: 'background 0.2s',
  },
  td: {
    padding: '10px 8px',
    color: '#475569',
  },
  tdNum: {
    padding: '10px 8px',
    color: '#475569',
    textAlign: 'right',
  },
  tdActions: {
    padding: '10px 8px',
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
  },
  badge: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '600',
  },
  btnVer: {
    padding: '6px 12px',
    background: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  btnImprimir: {
    padding: '6px 10px',
    background: '#10b981',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  
  // Modal
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    background: 'white',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '600px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 30px',
    borderBottom: '1px solid #e2e8f0',
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#1e293b',
    margin: 0,
  },
  btnCerrar: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: '#64748b',
    cursor: 'pointer',
    padding: '0',
    width: '30px',
    height: '30px',
  },
  modalBody: {
    padding: '30px',
  },
  detalleGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px',
    marginBottom: '30px',
  },
  detalleItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  detalleLabel: {
    fontSize: '12px',
    color: '#64748b',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  detalleValue: {
    fontSize: '15px',
    color: '#1e293b',
    fontWeight: '500',
  },
  modalActions: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    paddingTop: '20px',
    borderTop: '1px solid #e2e8f0',
  },
  btnModalImprimir: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
    transition: 'all 0.2s',
  },
};

export default EntradasHistorial;